import { fun_PostAction } from "@/api/index";
import "../../../../utils/security.js";
export default {
  data() {
    // 密码正则
    const reg = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/;
    // 新密码和原密码比对
    const validateNewPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (!reg.test(value)) {
        callback(new Error("请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"));
      } else if (value === this.form.ymm) {
        callback(new Error("新密码和原密码不能重复！"));
      } else {
        callback();
      }
    }
    // 新密码和确认密码比对
    const validateComPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (!reg.test(value)) {
        callback(new Error("请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"));
      } else if (value !== this.form.yhmm) {
        callback(new Error("新密码和确认密码不一致！"));
      } else {
        callback();
      }
    }
    return {
      // 表单对象
      form: {
        ymm: null, // 原密码
        yhmm: null, // 新密码
        yhmmqr: null  // 确认密码
      },
      // 表单对象
      request: {
        exponent: null, // 加密exponent参数
        modulus: null, // 加密modulus参数
        ymm: null, // 原密码
        yhmm: null, // 新密码
        yhmmqr: null  // 确认密码
      },
      // 表单配置
      formConfigList: [
        {
          title: "密码修改",
          name: "1",
          icon: "",
          tipsList: [
            { text: "特殊字符请在_ ~ ! @ # $ ^ & . 中选择，除此之外的其他特殊符号不可用。" }
          ],
          formConfigList: [
            {
              label: "原密码：",
              value: "ymm",
              slotName: "ymm",
              type: "slot",
              tip: "（可输入20个字符）",
              required: true,
              rule: [
                {
                  required: true,
                  message: "请输入原密码",
                  trigger: "blur"
                }
              ]
            },
            {
              label: "新密码：",
              value: "yhmm",
              slotName: "yhmm",
              type: "slot",
              tip: "（可输入20个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种！）",
              required: true,
              rule: [
                {
                  required: true,
                  message: "请输入新密码",
                  trigger: "blur"
                },
                {
                  validator: validateNewPass,
                  trigger: "blur"
                }
              ]
            },
            {
              label: "确认密码：",
              value: "yhmmqr",
              slotName: "yhmmqr",
              type: "slot",
              tip: "（可输入20个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种！）",
              required: true,
              rule: [
                {
                  required: true,
                  message: "请再次输入新密码",
                  trigger: "blur"
                },
                {
                  validator: validateComPass,
                  trigger: "blur"
                }
                // {
                //   pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z_!@#$^&~.]+$)(?![a-z0-9]+$)(?![a-z_!@#$^&~.]+$)(?![0-9_!@#$^&~.]+$)[a-zA-Z0-9_!@#$^&~.]{8,20}$/,
                //   message:
                //     "请至少输入8个字符且至少包含大写字母、小写字母、数字、特殊字符中任意3种"
                // }
              ]
            },
          ]
        }
      ],
      key: null, // 加密key
      // 全局加载
      fullLoading: null,
    };
  },
  // 模板编译完成
  mounted() {
    // 调用获取参数方法
    this.fun_GetRSAKey();
  },
  // 自定义方法
  methods: {
    /**
     * 获取参数接口
     * @author 滕威
     */
    fun_GetRSAKey() {
      // 调用获取加密参数接口
      fun_PostAction("/getRSAKey").then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 获取exponent
          this.request.exponent = data.exponent;
          // 获取modulus
          this.request.modulus = data.modulus;
        }
      });
    },
    /**
     * @description 保存
     * @author
     */
    fun_Save() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          // 获取加密key
          this.key = window.RSAUtils.getKeyPair(this.request.exponent,"", this.request.modulus);
          // 遍历加密用户名、密码、验证码
          for (let e in this.form) {
            this.request[e] = window.RSAUtils.encryptedString(this.key, this.form[e]);
          }
          // 提交
          this.fun_Submit();
        } else {
          return false;
        }
      });
    },
    /**
     * 提交
     */
    fun_Submit() {
      try {
        // 打开loading
        this.loading = true;
        // 打开遮罩
        this.fun_Loading();
        // 执行获取列表接口
        fun_PostAction("/loginPassword/loginPasswordUpdate", {
          ...this.request
        }).then(res => {
          // 加载框取消
          this.fullLoading.close();
          // 解构res.data
          const { result, msg } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 提示，并清除选中数据
            this.$alert(msg, "warning").then(() => {
              // 删除存储
              this.resetSetItem("flag", "");
              // 跳转工作台
              this.$router.push({path: "/home"});
            }).catch(() => {
              // 删除存储
              this.resetSetItem("flag", "");
              // 跳转工作台
              this.$router.push({path: "/home"});
            });
          } else {
            // 请求失败的场景
            // 请求失败，弹出失败msg的消息提示
            this.$message.error(msg);
          }
          // 关闭loading
          this.loading = false;
        })
        .catch(() => {
          // 加载框取消
          this.fullLoading.close();
        });
      } catch {
        // 关闭loading
        this.loading = false;
        // 加载框取消
        this.fullLoading.close();
      }
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
  }
};
